





















































import { Component, Vue, Prop } from 'vue-property-decorator';
import TravelPackService from '../../services/TravelPackService';
import ApiHelper from '../../helpers/api-helper';
import ValidationHelper from '../../helpers/validation-helper';
import Trigger from '../core/Trigger.vue';
import TagPackageFilter from '../filters/TagPackageFilter.vue';
import Hero from '../core/Hero.vue';
import PackageOrder from '../filters/PackageOrder.vue';
import CardPackage from '../core/CardPackage.vue';
import Toast from '../core/Toast.vue';
import SidebarModify from '../modals/SidebarModify.vue';
import Alert from '../core/Alert.vue';
import Appbar from '../core/Appbar.vue';
import Footer from '../core/Footer.vue';
import Sidebar from '../core/Sidebar.vue';
import {ValidationObserver, ValidationProvider} from 'vee-validate';

@Component({
	components: {
		Trigger,
		TagPackageFilter,
		Hero,
		PackageOrder,
		CardPackage,
		Toast,
		SidebarModify,
		Alert,
		Appbar,
		Footer,
		Sidebar,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class SearchPackageForm extends Vue {
	private pagination: any;
	private showPackage: any;
	private itemsPackages: any[];
	private itemsPackagesOld: any[];
	private apiFilters: any;
	private filters: any;
	private offer: any;
	private atLeastFirstCall: any;
	private order: any;
	private tags: any;
	private element: any;
	private loadingMore: boolean;
	private isMobile: boolean;
	private seo_title: string;
	private seo_description: string;
	private seo_url: string;
	private seo_h1: string;

	constructor() {
		super();
		this.showPackage = 0;
		this.itemsPackages = [];
		this.itemsPackagesOld = [];
		this.apiFilters = {};
		this.filters = {};
		this.offer = false;
		this.loadingMore = false;
		this.isMobile = false;
		this.pagination = {
			page: 1,
			itemsPerPage: 20,
			sortBy: [],
		};
		this.atLeastFirstCall = false;
		this.order = 'total_amount';
		this.seo_title = 'Buscador de Viajes Fin de Curso - Encuentra el mejor viaje de grupo para tu colegio';
		this.seo_description = 'Descubre el Buscador de Viajes Fin de Curso definitivo y encuentra el viaje de grupo ideal para tu colegio. Nuestra plataforma inteligente compara y selecciona las mejores opciones de destinos, actividades y alojamientos adaptados a tus necesidades y presupuesto. ¡Organiza un viaje inolvidable y crea recuerdos que durarán toda la vida con la herramienta líder en planificación de viajes escolares!';
		this.seo_url = process.env.APP_URL + 'buscador';
		this.seo_h1 = '¿Tenéis claro el presupuesto, pero no la ciudad?';
	}

	async fetch() {
		this.isMobile = process.client ? window.innerWidth < 768 : false;
		this.pagination.itemsPerPage = this.isMobile ? 6 : 20;
		const currentSearchPackage = this.$store.getters.searchPackage;
		if (currentSearchPackage) {
			this.itemsPackages = currentSearchPackage.itemsPackages;
			this.itemsPackagesOld = currentSearchPackage.itemsPackagesOld;
			this.showPackage = currentSearchPackage.showPackage;
			this.apiFilters = currentSearchPackage.apiFilters;
			this.filters = currentSearchPackage.filters;
			this.order = currentSearchPackage.order;
			this.tags = currentSearchPackage.tags;
		}
		if (this.$route.query.budget) {
			this.filters.budget = this.$route.query.budget;
		}
		if (this.$route.query.country_id) {
			this.filters.country_id = this.$route.query.country_id;
		}
		if (this.$route.query.city_id) {
			this.filters.city_id = this.$route.query.city_id;
		}
		await this.searchPackage();
	}

	head() {
		return {
			title: this.seo_title,
			meta: [
				{ hid: 'og:title', property: 'og:title', content: this.seo_title},
				{ hid: 'description', name: 'description', content: this.seo_description},
				{ hid: 'og:description', property: 'og:description', content: this.seo_description},
				{ hid: 'og:url', property: 'og:url', content: this.seo_url  },
			],
		};
	}

	async searchPackage() {
		this.apiFilters = this.offer == 1 ? { offer: 1 } : {};
		this.apiFilters = {
			...this.apiFilters,
			...this.filters,
		};
		this.itemsPackages = [];
		this.pagination.page = 1;
		await TravelPackService.list(this.$axios, this.pagination, this.apiFilters, this.order)
			.then(res => {
				this.itemsPackages = res.elements;
				this.itemsPackagesOld = res.elements;
				this.showPackage = 1;
				this.atLeastFirstCall = true;
				if (res.city_name && res.country_name) {
					this.seo_title = 'Viajes Fin de Curso en ' + res.city_name + ' | Paquetes Escolares Personalizados - Fin de Curso Colegio';
					this.seo_description = 'Descubre paquetes de viajes de fin de curso escolar en ' + res.city_name + ' con Fin de Curso Colegio. Encuentra el viaje fin de curso a ' + res.city_name + ' o cualquier otra ciudad de '  + res.country_name + ' que más se ajuste a vuestras necesidades';
					this.seo_h1 = 'Viajes para grupos escolares en ' + res.city_name;
				} else if (res.country_name) {
					this.seo_title = 'Viajes Fin de Curso escolares| Paquetes Personalizados para Colegios por  ' + res.country_name + ' - Fin de Curso Colegio';
					this.seo_description = 'Encuentra paquetes de viajes de fin de curso para colegios en Fin de Curso Colegio. Configura el viaje perfecto para tus estudiantes con opciones personalizadas de alojamiento, transporte y actividades. ¡Celebra el viaje fin de curso con una experiencia inolvidable!';
					this.seo_h1 = 'Viajes para grupos escolares en ' + res.country_name;
				}
			})
			.catch(error => {
				this.atLeastFirstCall = true;
				ApiHelper.handleErrors(error, {}, this.$nuxt);
			});
	}

	loadMore() {
		this.pagination.page++;
		this.loadingMore = true;
		TravelPackService.list(this.$axios, this.pagination, this.apiFilters, this.order)
			.then(res => {
				this.itemsPackages = [...this.itemsPackages, ...res.elements];
				this.loadingMore = false;
			})
			.catch(error => {
				this.loadingMore = false;
				ApiHelper.handleErrors(error, {}, this.$nuxt);
			});
	}

	packageFilterTag(tags) {
		this.tags = tags;
		const filtered: any = [];
		let exist = 0;
		this.itemsPackages = this.itemsPackagesOld;
		if (tags.length != 0) {
			for (const itemPackage of this.itemsPackages) {
				if (tags.length == 1) {
					if (itemPackage.tags.indexOf(tags[0]) != -1) {
						filtered.push(itemPackage);
					}
				} else if (tags.length > 1) {
					if (ValidationHelper.allElementsInArray(itemPackage.tags, tags)) {
						filtered.push(itemPackage);
					}
				}
			}
			this.itemsPackages = filtered;
		}
	}

	selectPackage(value) {
		this.$store.commit('setSearchPackage', {
			itemsPackages: this.itemsPackages,
			itemsPackagesOld: this.itemsPackagesOld,
			showPackage: this.showPackage,
			apiFilters: this.apiFilters,
			filters: this.filters,
			order: this.order,
			tags: this.tags,
		});
		this.$router.push({ path: 'reserva-buscador/' + value.slug});
	}
}
